import { appRouterPaths } from "@/services/navigation";
import { CalendarPageV2 } from "@/pages";
import type { RouteProps } from "react-router-dom";

export const calendarV2PageRoute: RouteProps = {
  path: appRouterPaths.calendarV2,
  element: <CalendarPageV2 />,
};
